<template>
    <div>
        <FormDynamic 
            :form_format="form_format"
            :form_data="form_data"
            :array_options="array_options"
            :content_align_x="'xx'"
        />
        <div class="mt-3 d-flex align-items-center justify-content-center">
            <a style="width: 220px !important;" class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Search'" @click="$emit('resetList', {})"/>
        </div>
    </div>
</template>

  
  
<script>
import FormDynamic  from '@/components/FormDynamic.vue'

export default {
    name: "LocalFormSearch",

    components: {
        FormDynamic,
    },

    props: [
        "array_options",
        "form_format",
        "form_data",
    ],

    data() {
        return {

        };
    },

    mounted() 
    {
        window.addEventListener('keydown', this.handleEnterKey);
    },
    beforeDestroy() 
    {
        window.removeEventListener('keydown', this.handleEnterKey);
    },

    methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.$emit('resetList', {})
      }
    },
  }
};
</script>
